import React, { useState } from 'react';
import SportAdmin from './SportAdmin';
import PlanManagement from './PlanManagement';
import ModuleManagement from './ModuleManagement';
import './Administration.css';

const Administration = () => {
  const [activeTab, setActiveTab] = useState('sports');

  const tabs = [
    { id: 'sports', label: 'Deportes', icon: '🏃‍♂️' },
    { id: 'plans', label: 'Planes', icon: '💰' },
    { id: 'modules', label: 'Módulos', icon: '🔧' },
    // Future admin tabs can be added here
    // { id: 'users', label: 'Usuarios', icon: '👥' },
    // { id: 'sites', label: 'Sitios', icon: '🏢' },
  ];

  return (
    <div className="administration">
      <div className="administration-header">
        <h1>Administración del Sistema</h1>
        <p>Gestiona los recursos globales del sistema</p>
      </div>

      <div className="administration-content">
        <div className="admin-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="admin-content">
          {activeTab === 'sports' && <SportAdmin />}
          {activeTab === 'plans' && <PlanManagement />}
          {activeTab === 'modules' && <ModuleManagement />}
          {/* Future admin content can be added here */}
        </div>
      </div>
    </div>
  );
};

export default Administration;
